export default __webpack_public_path__ + "static/media/fairy.8b663435.svg";